import axios from "axios";
import { configUrl } from "config.js";

const assignCourseTests = async (courseId, scheduleStartDateValue, scheduleEndDateValue, assignDateValue, IsScheduleOverride) => {
  return axios.put(`${configUrl.AssessmentServer}/api/Courses/assignCourseTests/${courseId}`, {
    scheduleStartDateTime: scheduleStartDateValue,
    scheduleEndDateTime: scheduleEndDateValue,
    assignDateTime: assignDateValue,
    IsScheduleOverride: IsScheduleOverride
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error?.response?.data, "prevError");
      return {
        messege: error?.response?.data,
        status: error?.response?.status
      }
    });

};
export default {
  assignCourseTests: assignCourseTests,
}
